<template>
    <svg width="96" height="96" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore -->
        <g fill="none" fill-rule="evenodd">
            <!-- @vue-ignore -->
            <g stroke="currentColor" stroke-width="2">
                <path
                    d="M47.619 9c10.769 0 20.517 4.407 27.574 11.531a39.438 39.438 0 0 1 11.414 26.85H8.63a39.438 39.438 0 0 1 11.414-26.85C27.102 13.407 36.851 9 47.62 9Z"
                />
                <path d="M27.91 76.16c0 5.443 4.411 9.855 9.854 9.855s9.855-4.412 9.855-9.855V47.295" />
            </g>
        </g>
    </svg>
</template>
